import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ParagraphDto } from './paragraph.model';

export const ParagraphActions = createActionGroup({
  source: 'Paragraph API',
  events: {
    'Get Paragraph By Ids Success': props<{ paragraphs: ParagraphDto[] }>(),
    'Get Paragraph By Ids Failure': props<{ error: Error }>(),
    'Get Paragraph By Id': emptyProps(),
    'Get Paragraph By Id Success': props<{ paragraph: ParagraphDto }>(),
    'Get Paragraph By Id Failure': props<{ error: Error }>(),
  },
});
